const headerComponent = document.getElementsByClassName('header')[0];
const headerContainer = document.getElementsByClassName('header-container')[0];

// Header scroll
if (headerComponent) {
  const scrollContainer = () => document.documentElement || document.body;



  // menu handlers

  // check mobile menu show/hide condition
  const mobileMenuStartPoint = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      '--mobile-menu-start-point'
    )
  );
  let isMobileMenuEnable =
    window.outerWidth <= mobileMenuStartPoint ||
    document.querySelector('.header-mobile');

  const desktopDropdownBreakpoint = 1200;
  const headerDropdownActiveClass = 'is-dropdown-active';
  const dropdownVisibleClass = 'is-visible';
  const dropdownItems = document.querySelectorAll('.menu-item.dropdown');
  const dropdownLinks = document.querySelectorAll('.menu-item.dropdown > .menu-link');
  const isDesktopDropdownMode = () => window.innerWidth > desktopDropdownBreakpoint;
  let desktopDropdownCloseTimeout = null;

  const syncDesktopDropdownWidth = () => {
    dropdownItems.forEach((item) => {
      const dropdownMenu = item.querySelector('.dropdown-menu');

      if (!dropdownMenu) {
        return;
      }

      if (!isDesktopDropdownMode()) {
        dropdownMenu.style.removeProperty('--dropdown-menu-width');
        return;
      }

      const dropdownLinksEls = Array.from(
        dropdownMenu.querySelectorAll('.menu-link')
      );

      let maxLinkWidth = 0;

      dropdownLinksEls.forEach((link) => {
        maxLinkWidth = Math.max(maxLinkWidth, Math.ceil(link.scrollWidth));
      });

      const contentWidth = maxLinkWidth ? maxLinkWidth + 56 : 200;
      dropdownMenu.style.setProperty(
        '--dropdown-menu-width',
        `${Math.max(contentWidth, 200)}px`
      );
    });
  };

  const cancelDesktopDropdownClose = () => {
    if (desktopDropdownCloseTimeout) {
      clearTimeout(desktopDropdownCloseTimeout);
      desktopDropdownCloseTimeout = null;
    }
  };

  const showDesktopDropdown = (item) => {
    const dropdownMenu = item?.querySelector('.dropdown-menu');

    if (!dropdownMenu) {
      return;
    }

    dropdownMenu.style.display = 'block';

    window.requestAnimationFrame(() => {
      dropdownMenu.classList.add(dropdownVisibleClass);
    });
  };

  const hideDesktopDropdown = (item) => {
    const dropdownMenu = item?.querySelector('.dropdown-menu');

    if (!dropdownMenu) {
      return;
    }

    dropdownMenu.classList.remove(dropdownVisibleClass);

    window.setTimeout(() => {
      if (!item.classList.contains('active')) {
        dropdownMenu.style.display = '';
      }
    }, 240);
  };

  const setActiveDesktopDropdown = (currentDropdown) => {
    dropdownItems.forEach((item) => {
      const isCurrent = item === currentDropdown;

      item.classList.toggle('active', isCurrent);

      if (isCurrent) {
        showDesktopDropdown(item);
      } else {
        hideDesktopDropdown(item);
      }
    });

    if (currentDropdown) {
      headerComponent.classList.add(headerDropdownActiveClass);
    } else {
      headerComponent.classList.remove(headerDropdownActiveClass);
    }
  };

  const clearDesktopDropdownState = () => {
    cancelDesktopDropdownClose();
    dropdownItems.forEach((item) => {
      item.classList.remove('active');
      hideDesktopDropdown(item);
    });
    headerComponent.classList.remove(headerDropdownActiveClass);
  };

  const scheduleDesktopDropdownClose = () => {
    if (!isDesktopDropdownMode()) {
      return;
    }

    cancelDesktopDropdownClose();
    desktopDropdownCloseTimeout = window.setTimeout(() => {
      clearDesktopDropdownState();
    }, 120);
  };

  dropdownLinks.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      if (!isDesktopDropdownMode()) {
        return;
      }

      const currentDropdown = link.closest('.menu-item.dropdown');
      cancelDesktopDropdownClose();
      setActiveDesktopDropdown(currentDropdown);
    });
  });

  dropdownItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      if (!isDesktopDropdownMode()) {
        return;
      }

      cancelDesktopDropdownClose();
      setActiveDesktopDropdown(item);
    });

    item.addEventListener('mouseleave', () => {
      if (!isDesktopDropdownMode()) {
        return;
      }

      scheduleDesktopDropdownClose();
    });
  });

  const dropdownToggle = document.querySelectorAll('.dropdown-toggle');

  dropdownToggle.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      if (isMobileMenuEnable) {
        const isLinkedDropdown = this.hasAttribute('data-delivery-section-menu-link') || this.hasAttribute('data-home-section-menu-link');

        if (isLinkedDropdown && !e.target.closest('.menu-link__arrow')) {
          return;
        }

        const menuItem = this.closest('.menu-item.dropdown');
        const dropdownMenu = this.nextElementSibling;
        if (!menuItem || !dropdownMenu) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        const isAlreadyActive = menuItem.classList.contains('active');

        // close all opened sub menu
        const activeDropdowns = document.querySelectorAll(
          '.menu-item.dropdown.active .dropdown-menu'
        );
        activeDropdowns.forEach((menu) => {
          menu.style.display = 'none';
          menu.closest('.dropdown').classList.remove('active');
        });

        if (isAlreadyActive) {
          return;
        }

        // open current submenu
        menuItem.classList.add('active');
        dropdownMenu.style.display = 'block';
      }
    });
  });

  // toggle menu handler
  function menuToggleFunc() {
    const burgerBtn = document.querySelector('.burger-btn');
    const menuToggle = document.querySelector('.menu-toggle');
    const navbarNav = document.querySelector('.navbar-nav');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');

    headerComponent.classList.toggle('is-open-menu');
    if (burgerBtn) burgerBtn.classList.toggle('active');
    if (menuToggle) menuToggle.classList.toggle('active');
    if (navbarNav) navbarNav.classList.toggle('active');
    if (headerCloseWrapper) headerCloseWrapper.classList.toggle('active');

    // LockScroll when burger open and enable when closed and enable scroll on menu
    if (scrollLock.getScrollState()) {
      scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
      scrollLock.addScrollableSelector('.simplebar-content-wrapper');
      window.lenis?.stop();
    } else {
      scrollLock.enablePageScroll();
      window.lenis?.start();
    }
  }

  function closeMobileMenu() {
    if (!headerComponent.classList.contains('is-open-menu')) {
      return;
    }

    const burgerBtn = document.querySelector('.burger-btn');
    const menuToggle = document.querySelector('.menu-toggle');
    const navbarNav = document.querySelector('.navbar-nav');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');
    const activeMenuItems = document.querySelectorAll('.menu-item.active');
    const dropdownMenus = document.querySelectorAll('.dropdown-menu');

    headerComponent.classList.remove('is-open-menu');
    if (burgerBtn) burgerBtn.classList.remove('active');
    if (menuToggle) menuToggle.classList.remove('active');
    if (navbarNav) navbarNav.classList.remove('active');
    if (headerCloseWrapper) headerCloseWrapper.classList.remove('active');

    activeMenuItems.forEach((item) => {
      item.classList.remove('active');
    });

    dropdownMenus.forEach((menu) => {
      if (!isDesktopDropdownMode()) {
        menu.style.display = 'none';
      }
    });

    scrollLock.enablePageScroll();
    window.lenis?.start();
  }

  // menu update function
  function updateMenu() {
    isMobileMenuEnable =
      window.outerWidth <= mobileMenuStartPoint ||
      document.querySelector('.mobile-header');

    if (!isDesktopDropdownMode()) {
      clearDesktopDropdownState();
    }

    syncDesktopDropdownWidth();

    if (!isMobileMenuEnable) {
      const dropdownMenus = document.querySelectorAll('.dropdown-menu');
      dropdownMenus.forEach((menu) => {
        menu.style.display = '';
        menu.classList.remove(dropdownVisibleClass);
      });

      const headerCloseWrapper = document.querySelector(
        '.header-close-wrapper'
      );
      headerCloseWrapper.classList.remove('active');

      const activeMenuItems = document.querySelectorAll('.menu-item.active');
      activeMenuItems.forEach((item) => {
        item.classList.remove('active');
      });

      const navbarNav = document.querySelector('.navbar-nav');
      navbarNav.classList.remove('active');

      const menuToggle = document.querySelector('.menu-toggle');
      if (menuToggle) menuToggle.classList.remove('active');

      const burgerBtn = document.querySelector('.burger-btn');
      if (burgerBtn) burgerBtn.classList.remove('active');

      headerComponent.classList.remove('is-open-menu');

      // LockScroll when burger open and enable when closed
      scrollLock.enablePageScroll();
      window.lenis?.start();
    }
  }

  window.addEventListener('resize', updateMenu);
  window.addEventListener('orientationchange', updateMenu);
  window.addEventListener('load', syncDesktopDropdownWidth);

  // end of toggle menu handler

  const burgerBtn = document.querySelector('.burger-btn');
  const headerCloseWrapper = document.querySelector('.header-close-wrapper');

  if (burgerBtn) burgerBtn.addEventListener('click', menuToggleFunc);
  if (headerCloseWrapper) headerCloseWrapper.addEventListener('click', menuToggleFunc);

  const navbarNav = document.querySelector('.navbar-nav');

  if (navbarNav) {
    navbarNav.addEventListener('click', (event) => {
      const closeTrigger = event.target.closest('[data-close-mobile-menu]');

      if (!closeTrigger || !isMobileMenuEnable || !headerComponent.classList.contains('is-open-menu')) {
        return;
      }

      closeMobileMenu();
    }, true);

    navbarNav.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      const isLinkedDropdownToggle = link?.classList.contains('dropdown-toggle')
        && (link.hasAttribute('data-delivery-section-menu-link') || link.hasAttribute('data-home-section-menu-link'));

      if (!link || !isMobileMenuEnable || !headerComponent.classList.contains('is-open-menu') || (link.classList.contains('dropdown-toggle') && !isLinkedDropdownToggle)) {
        return;
      }

      closeMobileMenu();
    });
  }

  // Hide and show Header when scroll up
  function headerSticky() {
    let prevScrollPos = window.scrollY;

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const headerHeight = headerComponent.scrollHeight;

      if (currentScrollPos > 100) {
        if (prevScrollPos > currentScrollPos) {
          headerComponent.style.top = window.innerWidth > 768 ? '0' : '0';
          headerComponent.classList.add('scrolled');
        } else {
          headerComponent.style.top = `-${headerHeight + 3}px`;
        }
      } else {
        headerComponent.style.top = '0';
        if (currentScrollPos === 0) {
          headerComponent.classList.remove('scrolled');
        } else {
          headerComponent.classList.add('scrolled');
        }
      }

      prevScrollPos = currentScrollPos;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  headerSticky();
  syncDesktopDropdownWidth();
}
